import React from "react";
import { FaHome, FaSignOutAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/css/topbar.css";

function DepartmentTopbar() {
  const navigate = useNavigate();
  const username = localStorage.getItem('type');
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("adminUser");
    navigate("/department");
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <h2 className="text-white">Department Desk ({username})</h2>
      </div>
      <div className="topbar-right">
        <Link
          className="text-white text-decoration-none"
          to="/departmentDashbord"
        >
          <div className="icon-circle">
            <FaHome className="icon" />
          </div>
        </Link>

        <div className="icon-circle" onClick={handleLogout}>
          <FaSignOutAlt className="icon" />
        </div>
      </div>
    </div>
  );
}

export default DepartmentTopbar;
